import { render, staticRenderFns } from "./orderSellComp.vue?vue&type=template&id=612b0a68"
import script from "./orderSellComp.vue?vue&type=script&lang=js"
export * from "./orderSellComp.vue?vue&type=script&lang=js"
import style0 from "./orderSellComp.vue?vue&type=style&index=0&id=612b0a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports